import { render } from "./HistoryDescriptionModal.vue?vue&type=template&id=65832b1b&scoped=true"
import script from "./HistoryDescriptionModal.vue?vue&type=script&lang=js"
export * from "./HistoryDescriptionModal.vue?vue&type=script&lang=js"

import "./HistoryDescriptionModal.vue?vue&type=style&index=0&id=65832b1b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65832b1b"]])

export default __exports__